<template>
  <div :class="{off: !item.service, pause: item.disabled, isOpen: item.open, isCurrent: isCurrent, isInvalid: item.isDisabled}"
    :data-id="code"
    :data-category="item.category"
    :style="{
      zIndex: zIndex
    }"
    @click="setZIndex">
    <div class="amenityInner">

      <img :src="thumb" alt="" class="thumbImg" />
      <button v-if="item.thumb" type="button" class="delThumb" @click="deleteImage"></button>
      <div v-else class="uploadBox">
        <input type="file" :id="`upload_${code}_thumb`" @change="uploadImage($event)">
        <label :for="`upload_${code}_thumb`" class="uploadThumb"></label>
      </div>

      <p class="name toCapitalize">{{getItemName}}</p>
      <p class="code"><span>{{item.raCode}}</span></p>
      <p v-if="item.isDisabled && invalidMessage" class="colorRed invalidMessage">{{ invalidMessage }}</p>
    </div>
    <div class="checkbox chkService">
      <input type="checkbox" :id="`service_${code}`" v-model="item.service" />
      <label :for="`service_${code}`"><span class="blind">{{locale.state_public}}</span></label>
    </div>
    <div class="chkDisabled">
      <input type="checkbox" :id="`disabled_${code}`" :disabled="item.isDisabled" v-model="item.disabled" />
      <label :for="`disabled_${code}`"><span class="blind">{{locale.pause}}</span></label>
    </div>
    <div class="fold">
      <button type="button" class="btnFold" @click="fold"></button>
    </div>
    <div v-if="item.open" class="option">
      <!-- label -->
      <div class="translation">
        <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click="toggleLanguageLayer">
          <span class="blind">{{locale.language_specific_set}}</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
        </button>
      </div>
      <!-- //label -->
      <!-- 카테고리 -->
      <div class="optionItem">
        <label class="optionLabel">{{locale.category}}</label>
        <select class="optionValue input" v-model="item.category">
          <option
            v-for="item in category"
            :key="item"
            :value="item">
            {{amenityCategory(item)}}
            </option>
        </select>
      </div>
      <!-- //카테고리 -->
      <!-- 최대개수 -->
      <div class="optionItem">
        <label class="optionLabel">{{locale.max}}</label>
        <input type="text" class="optionValue input" v-model="item.max" @input="inputNumber('max')">
      </div>
      <!-- //최대개수 -->
      <!-- pid -->
      <div class="optionItem">
        <label class="optionLabel">{{locale.product_id}}</label>
        <input type="text" class="optionValue input" v-model="item.pid">
      </div>
      <!-- //pid -->
      <!-- 금액
      <div class="optionItem">
        <label class="optionLabel">{{locale.price}}</label>
        <input type="text" class="optionValue input" @input="inputPrice('price')" v-model="item.price">
      </div>
      //금액 -->
      <!-- 요청 제한 -->
      <div v-if="setting.integration" class="optionItem">
        <label class="optionLabel">{{locale.order_limit}}</label>
        <div class="checkbox">
          <input type="checkbox" :id="`${item.raCode}_limitActive`" v-model="item.orderLimitActive" />
          <label :for="`${item.raCode}_limitActive`">{{locale.apply_limit}}</label>
        </div>
      </div>
      <!-- //요청 제한 -->
      <!-- 기간, 횟수 -->
      <div v-if="setting.integration && item.orderLimitActive" class="mt10">
        <div class="optionItem">
          <label class="optionLabel">{{locale.order_limit_term}}</label>
          <div>
            <div class="checkbox radio">
              <input type="radio" :name="`${item.raCode}_orderLimit`" :id="`${item.raCode}_orderLimit_day`" value="day" v-model="item.orderLimit" />
              <label :for="`${item.raCode}_orderLimit_day`">1{{locale.day}}</label>
            </div>
          </div>
          <div class="mt5">
            <div class="checkbox radio">
              <input type="radio" :name="`${item.raCode}_orderLimit`" :id="`${item.raCode}_orderLimit_ota`" value="ota" v-model="item.orderLimit" />
              <label :for="`${item.raCode}_orderLimit_ota`">{{locale.stay_period}}</label>
            </div>
          </div>
        </div>
        <div class="optionItem">
          <label class="optionLabel">{{locale.order_number}}</label>
          <input type="text" class="optionValue input" @input="inputNumber('orderMax')" v-model="item.orderMax">
        </div>
        <div class="optionItem">
          <label class="optionLabel">{{locale.switch_pay}}</label>
          <div class="checkbox">
            <input type="checkbox" :id="`${item.raCode}_pay`" v-model="item.pay" />
            <label :for="`${item.raCode}_pay`">{{locale.apply_switch}}</label>
          </div>
        </div>
        <div v-if="item.pay" class="optionItem">
          <label class="optionLabel">{{locale.price}}</label>
          <input type="text" class="optionValue input" @input="inputPrice('price')" v-model="item.price">
        </div>
      </div>
      <!-- //기간, 횟수 -->
    </div>
    <!-- 언어별 세팅 -->
    <LangValue v-if="languageLayer" :langValue="langValue" :title="locale.language_specific_set" @close="toggleLanguageLayer" />
    <!-- //언어별 세팅 -->
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import LangValue from '@/components/Util/LangValue.vue'

export default {
  props: [
    'locale',
    'localeAmenity',
    'item',
    'zIndex',
    'isCurrent',
    'index'
  ],
  components: {
    LangValue
  },
  computed: {
    lang () {
      return this.$store.getters['setting/getData'].lang.default
    },
    code () {
      return this.item.raCode.toLowerCase()
    },
    category () {
      return this.$store.getters['amenity/getCategory']
    },
    getItemName () {
      const itemName = `amenity_${this.code}`
      const itemLabel = this.item.label && this.item.label[this.lang]
      return itemLabel || this.localeAmenity[itemName]
    },
    thumb () {
      const thumbnail = this.item.thumb
      const image = `${this.code}.png`
      return thumbnail || require(`@/assets/img/amenity/${image}`)
    },
    setting () {
      return this.$store.getters['amenity/getSetting']
    },
    invalidMessage () { // 강제품절처리
      let message
      const isInvalid = this.item.isDisabled
      // 제한여부
      const isLimit = this.item.orderLimitActive
      // 요청가능횟수0 + 유료전환하지 않음
      const noPay = isLimit && this.item.orderMax <= 0 && !this.item.pay
      // 요청가능횟수0 + 유료전환금액0
      const zeroPay = isLimit && this.item.pay && !(this.item.price && parseFloat(this.item.price) > 0)
      message = noPay
        ? this.locale.message_amenity_disabled_nopay // '요청가능 횟수가 0입니다. 유료 전환 하거나 요청가능 횟수를 1이상 입력해주세요.'
        : zeroPay
          ? this.locale.message_amenity_disabled_zeropay // '유료 전환 금액을 올바르게 입력하거나 유료 전환을 해제해주세요.'
          : null
      return message
    },
  },
  watch: {
    item: {
      deep: true,
      handler (data) {
        // 강제 disabled
        const isDisabled = this.item.disabled
        // 제한여부
        const isLimit = this.item.orderLimitActive
        // 요청가능횟수0 + 유료전환하지 않음
        const noPay = isLimit && this.item.orderMax <= 0 && !this.item.pay
        // 요청가능횟수0 + 유료전환금액0
        const zeroPay = isLimit && this.item.pay && !(this.item.price && parseFloat(this.item.price) > 0)
        this.item.isDisabled = (noPay || zeroPay) // 강제 disabled
        this.item.disabled = (noPay || zeroPay) || isDisabled
      }
    }
  },
  data () {
    let thumbnail = this.item.thumb || ''
    return {
      languageLayer: false,
      langValue: {},
      thumbnail
    }
  },
  methods: {
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          // this.item.thumbnail = res.source
          this.$store.commit('amenity/setItemData', {
            raCode: this.item.raCode,
            key: 'thumb',
            value: res.source || ''
          })
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage () {
      if (window.confirm(this.locale.confirm_delete)) {
        this.$store.commit('amenity/setItemData', {
          raCode: this.item.raCode,
          key: 'thumb',
          value: ''
        })
      }
    },
    toggleLanguageLayer () {
      const isOpen = !this.languageLayer
      if (isOpen) {
        this.langValue = this.item.label
      } else {
        this.item.label = this.langValue
        this.langValue = {}
      }
      this.languageLayer = !this.languageLayer
    },
    amenityCategory (categoryName) {
      const category = `amenity_category_${categoryName}`
      return this.locale[category]
    },
    fold () {
      this.item.open = !this.item.open
    },
    inputNumber (key) {
      const value = Number(regExp.numberOnly(this.item[key]))
      this.item[key] = value
    },
    inputPrice (key) {
      const value = regExp.numberOnly(this.item[key])
      this.item[key] = value
    },
    setZIndex () {
      this.$emit('setZIndex', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  &.isOpen {
    border-color: $color-dark;
    border-radius: 4px 4px 0 0;
    .btnFold:before {
      margin-top: -3px;
      border-top-color: transparent;
      border-bottom-color: $color-dgrey;
    }
  }
  &.isCurrent {
    border-color: $color-primary;
  }
  .code {
    font-size: 0.85em;
    color: $color-lgrey;
  }
  .fold {
    height: 24px;
    background-color: $color-white;
  }
}
.amenityInner {
  position: relative;
}
.uploadThumb {
  display: none;
  position: absolute;
  top: 30px;
  left: 50%;
  margin-left: -16px;
  width: 32px;
  height: 32px;
  border: 1px solid $color-lgrey;
  border-radius: 4px;
  background-color: $color-white;
  z-index: 1;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('~@/assets/img/ico_upload_image.png') 50% 50% / contain no-repeat;
    opacity: 0.5;
  }
}
.amenityInner:hover .uploadThumb {
  display: block;
}
.delThumb {
  position: absolute;
  top: 20px;
  left: 50%;
  width: 24px;
  height: 24px;
  margin-left: 16px;
  background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 12px no-repeat;
  opacity: 0.4;
}
.chkService {
  position: absolute;
  top: 5px;
  left: 5px;
}
.chkDisabled {
  position: absolute;
  top: 5px;
  right: 5px;
  label:before {
    content: "";
    display: block;
    width: 20px;
    height: 20px;
    background: url('~@/assets/img/ico_disabled_off.png') 50% 50% / contain no-repeat;
    opacity: 0.3;
    cursor: pointer;
  }
  :checked + label:before {
    background-image: url('~@/assets/img/ico_disabled_on.png');
    opacity: 1;
  }
}
.option {
  position: absolute;
  top: 100%;
  left: -1px;
  right: -1px;
  padding: 15px;
  border-radius: 0 0 4px 4px;
  border: 1px solid $color-dark;
  border-top-color: $color-lgrey2;
  background-color: $bg-default;
  z-index: 1;
}
.isCurrent {
  .option {
    border-color: $color-primary;
    border-top-color: $color-lgrey2;
  }
}
.optionItem {
  align-items: center;
  & + .optionItem {
    margin-top: 10px;
  }
  &.inActive {
    opacity: 0.5;
  }
  .optionLabel {
    display: block;
  }
  .input {
    min-width: 0;
    min-height: 0;
    padding: 0.2em 0.8em;
    border: 1px solid $color-lgrey2;
  }
}
.btnFold {
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  border-top: 1px solid $color-lgrey2;
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: 3px;
    border-style: solid;
    border-width: 6px;
    border-color: transparent;
    border-top-color: $color-lgrey2;
    transform: translate(-50%, -50%);
  }
}
.invalidMessage {
  margin-top: 8px;
  font-size: 10px;
}
.translation {
  position: absolute;
  top: 5px;
  right: 5px;
  .btnTranslation {
    position: static;
    width: 26px;
    height: 26px;
    border-radius: 4px;
    svg {
      position: static;
      width: 24px;
      height: 24px;
      transform: none;
    }
  }
}
</style>
